import { render } from "./EventsList.vue?vue&type=template&id=5a1c6c6e&scoped=true"
import script from "./EventsList.vue?vue&type=script&lang=js"
export * from "./EventsList.vue?vue&type=script&lang=js"

import "./EventsList.vue?vue&type=style&index=0&id=5a1c6c6e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5a1c6c6e"

export default script